<template>
  <div>
    <v-container fill-height fluid grid-list-xl class="pl-3 pt-2">
      <v-layout wrap>
        <v-flex xs6>
          <v-card
            style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
            class="mt-2"
          >
            <v-progress-linear
              :indeterminate="true"
              v-if="loading"
              color="success"
              class="mx-3"
            ></v-progress-linear>
            <v-layout row justify-space-between v-if="!loading">
              <v-layout column class="ma-1 px-3">
                <v-card-text
                  class="mb-0 pb-0 pt-2 pl-2"
                  v-if="donor && donor.personID"
                >
                  <div class="display-1 pt-2 font-weight-bold mb-0 ml-0">
                    {{ donor.nameH }}
                  </div>
                  <div class="ml-0 mt-4">
                    <div class="pl-3">
                      <v-layout row align-center class="mb-2">
                        <div class="font-weight-medium mr-2">
                          Donor ID:
                        </div>
                        <div>
                          {{ donor.personID }}
                        </div>
                        <genvite-portal-link
                          :uta-id="donor.personID"
                          class="ml-3"
                        ></genvite-portal-link>
                      </v-layout>
                      <v-layout row class="mb-2">
                        <div class="font-weight-medium mr-2">
                          Father:
                        </div>
                        <a class="" :href="donor.paternalGrandParentId">{{
                          donor.father
                        }}</a>
                      </v-layout>
                      <v-layout row class="mb-2">
                        <div class="font-weight-medium mr-2">
                          Father In Law:
                        </div>
                        <a class="" :href="donor.maternalGrandParentId">{{
                          donor.fatherInLaw
                        }}</a>
                      </v-layout>
                      <v-layout row class="mb-2">
                        <div class="font-weight-medium mr-2">
                          Address:
                        </div>
                        <div>
                          {{ donor.address1 }}
                        </div>
                      </v-layout>
                      <v-layout row class="mb-2">
                        <div class="font-weight-medium mr-2">
                          Email Address:
                        </div>
                        <div>
                          {{ donor.emailAddress }}
                        </div>
                      </v-layout>
                      <v-layout row class="mb-2" v-for="phone in phonesNumbers">
                        <div class="font-weight-medium mr-2">
                          {{ getPhoneType(phone.phoneType) }}:
                        </div>
                        <div>
                          {{ phone.phoneNum }}
                        </div>
                      </v-layout>
                    </div>
                  </div>
                </v-card-text>
              </v-layout>
            </v-layout>

            <v-spacer></v-spacer>
          </v-card>
        </v-flex>
        <v-flex xs6 fill-height>
          <v-card
            style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
            class="mt-2 pa-3"
          >
            <v-progress-linear
              :indeterminate="true"
              v-if="loadingChildren"
              color="success"
            ></v-progress-linear>
            <div v-if="!loadingChildren">
              <v-layout row class="pl-2 pr-3">
                <div class="title pt-3">Children</div>
                <v-spacer></v-spacer>
                <v-btn
                  v-if="!hasAluminiStudentQuery()"
                  @click="openAluminiDialog"
                  color="success"
                  small
                >
                  >Connect Alumini</v-btn
                >
              </v-layout>
              <v-divider class="pt-2"></v-divider>
            </div>
            <div class="body-1" v-if="!loadingChildren && !allChildren.length">
              No Married Children
            </div>

            <div v-for="(child, index) in allChildren" :key="child.personID">
              <a class="" :href="child.link">{{ child.displayName }}</a>
              <div
                v-if="child.aluminiPersons && child.aluminiPersons.length"
                class="child-mappings"
              >
                <v-layout
                  row
                  align-center
                  class="caption text-info child-mapping-row"
                  v-for="mapping in getChildAluminiMappings(child)"
                  :key="mapping.id"
                >
                  <div class="child-mapping-text">{{ mapping.displayName }}</div>
                  <v-btn
                    class="my-0 py-0 child-mapping-delete"
                    @click.stop="openDeleteMappedAluminiDialog(mapping)"
                    flat
                    icon
                    color="success"
                  >
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </v-layout>
              </div>
              <v-divider
                class="pt-1 mt-1 "
                v-if="index + 1 < allChildren.length"
              ></v-divider>
            </div>

            <v-spacer></v-spacer>
          </v-card>
        </v-flex>
        <v-flex xs12 class="pt-2" v-if="!hasLimitedView()">
          <v-card
            class="pa-3 mt-0"
            style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
          >
            <v-tabs color="success" dark icons-and-text>
              <v-tabs-slider color="#fff"></v-tabs-slider>

              <v-tab href="#donations">
                Donations ({{ transactions.length }})
                <v-icon>mdi-currency-usd</v-icon>
              </v-tab>

              <v-tab-item value="donations">
                <v-card-text
                  class="text-xs-center title mt-3"
                  v-if="!transactions.length"
                  >No Donations</v-card-text
                >

                <v-expansion-panel
                  v-if="transactions.length"
                  class="expansion-panel-margin mt-3"
                >
                  <v-expansion-panel-content
                    v-for="transaction in transactions"
                  >
                    <template v-slot:header>
                      <v-flex xs3 class="pl-0">
                        <v-layout row align-start class="pa-0 mx-0">
                          <v-layout column class="py-0 ma-0">
                            <v-flex xs3>
                              <v-layout row>
                                <v-icon
                                  class="mr-3"
                                  dark
                                  :color="getStatusIconColor(transaction)"
                                  >{{ getStatusIcon(transaction) }}</v-icon
                                >
                                <div>
                                  <div class="subheading mb-1">
                                    {{ transaction.dateTime | time }}
                                  </div>
                                  <div class="text--disabled subheading">
                                    {{ transaction.pmtType }}
                                  </div>
                                </div>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-flex>
                      <v-spacer></v-spacer>
                      <v-flex xs2>
                        <div class="body-2 font-weight-medium mb-1">
                          Source:
                        </div>
                        <div class="body-2 mb-1">
                          {{ transaction.source }}
                        </div>
                      </v-flex>
                      <v-spacer></v-spacer>
                      <v-flex xs3>
                        <v-layout column align-end class="mx-0 pr-4">
                          <div
                            class="subheading mb-1"
                            v-bind:class="{
                              'text-danger': transaction.amount < 0,
                            }"
                          >
                            {{ transaction.amount | currency }}
                          </div>
                          <!-- <div
                                                    class="text--disabled subheading"
                                                >
                                                    {{ transaction.pmtType }}
                                                </div> -->
                        </v-layout>
                      </v-flex>
                    </template>
                    <v-card>
                      <v-flex xs12>
                        <v-card-text class="subheading mt-2">
                          <v-layout row class="px-3 py-2">
                            <div class="font-weight-medium mr-2 width-200">
                              Date:
                            </div>
                            <div>
                              {{ transaction.dateTime | time }}
                            </div>
                          </v-layout>
                          <v-layout row class="px-3 py-2">
                            <div class="font-weight-medium mr-2 width-200">
                              Amount:
                            </div>
                            <div>
                              {{ transaction.amount | currency }}
                            </div>
                          </v-layout>
                          <v-layout row class="px-3 py-2">
                            <div class="font-weight-medium mr-2 width-200">
                              Last Updated:
                            </div>
                            <div>
                              {{ transaction.lastUpdated | time }}
                            </div>
                          </v-layout>
                          <v-layout
                            row
                            class="px-3 py-2"
                            v-for="prop in getProperties(transaction)"
                          >
                            <div class="font-weight-medium mr-2 width-200">
                              {{ prop.name }}:
                            </div>
                            <div>
                              {{ prop.value }}
                            </div>
                          </v-layout>
                        </v-card-text>
                      </v-flex>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-tab-item>
              <v-tab href="#sales">
                Sales ({{ sales.length }})
                <v-icon>mdi-domain</v-icon>
              </v-tab>
              <v-tab-item value="sales">
                <dedication-sales-by-parson-tab
                  :initial-data="{ donor: donor }"
                  @dedication-sales="sales = $event"
                />
              </v-tab-item>
              <v-tab href="#communication">
                Communications ({{ commCount }})
                <v-icon>mdi-account-switch</v-icon>
              </v-tab>
              <v-tab-item value="communication">
                <dedication-communications
                  v-if="Array.isArray(sales)"
                  :initial-data="{ donor: donor, sales: sales }"
                  @update-comm-count="commCount = $event"
                />
              </v-tab-item>
            </v-tabs>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="aluminiDialog" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline px-0 pt-2">Alumini Mapping</v-card-title>
        <v-layout row>
          <v-flex xs12
            ><v-btn
              small
              color="success"
              class="mt-0"
              @click="openNewAluminiMapping"
              v-if="!newAluminiMapping.show"
              >New Mapping</v-btn
            >
            <div v-if="newAluminiMapping.show" class="pr-3">
              <v-select
                label="Student"
                :items="alumini"
                v-model="newAluminiMapping.student"
                @change="studentSelected"
                ref="student"
                :rules="[rules.required]"
                item-disabled="disabled"
                item-text="displayName"
                item-value="displayName"
                clearable
                :disabled="isAluminiStudentLocked()"
              ></v-select>
              <v-select
                label="Child"
                :items="children"
                item-text="displayName"
                item-disabled="disabled"
                no-data-text="No Married Children"
                v-model="newAluminiMapping.child"
                ref="child"
                :rules="[rules.required]"
                clearable
                :disabled="!newAluminiMapping.student"
              >
                <template v-slot:item="data">
                  <template>
                    <v-list-tile-content>
                      <v-list-tile-title
                        v-html="data.item.displayName"
                      ></v-list-tile-title>
                      <v-list-tile-sub-title
                        v-html="data.item.mappingStatus"
                      ></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </template>
                </template>
              </v-select>
              <div class="text-info mb-2" v-if="getChildMapping()">
                {{ getChildMapping() }}
              </div>
              <v-select
                label="Type"
                :items="['Father', 'Mother']"
                disabled
                v-model="newAluminiMapping.type"
              ></v-select>
            </div>
          </v-flex>
        </v-layout>
        <v-card-actions class="pt-0 mr-2 mt-3">
          <v-spacer></v-spacer>
          <v-btn dark color="default" @click="aluminiDialog = false"
            >Close</v-btn
          ><v-btn :loading="processing" color="success" @click="saveAlumini()">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="deleteMappedDialog" max-width="400">
      <v-card class="pa-2">
        <v-card-title class="text-warning headline">Are You Sure?</v-card-title>
        <v-card-text class="mb-3 py-0">
          <div class="delete-family-line">
            Family: {{ aluminiToDelete.childDisplayName }}
          </div>
          <v-divider class="my-2"></v-divider>
          <div class="delete-mapping-caption">Mapping To Be Deleted</div>
          <div class="delete-mapping-info">
            {{ aluminiToDelete.mappingType }} Mapped to
            {{ aluminiToDelete.studentDisplayName }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="deleteMappedDialog = false"
            >Close</v-btn
          >
          <v-btn
            :loading="processing"
            color="success"
            @click="deleteAluminiMapping()"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="alreadyMappedDialog" max-width="460">
      <v-card class="pa-2">
        <v-card-title class="warning--text headline">
          Alumini Already Mapped
        </v-card-title>
        <v-card-text class="mb-2">
          <div class="mb-2">
            This student is already mapped to a family.
          </div>
          <div class="delete-family-line">
            Family: {{ alreadyMappedInfo.childDisplayName }}
          </div>
          <v-divider class="my-2"></v-divider>
          <div class="delete-mapping-caption">Current Mapping</div>
          <div class="delete-mapping-info">
            {{ alreadyMappedInfo.mappingType }} Mapped to
            {{ alreadyMappedInfo.studentDisplayName }}
          </div>
          <div class="caption grey--text mt-3">
            If you want to create a new mapping, delete this one first.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="alreadyMappedDialog = false">
            Close
          </v-btn>
          <v-btn
            :loading="processing"
            color="success"
            @click="deleteExistingStudentMapping()"
          >
            Delete Mapping
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="invalidAluminiStudentDialog" max-width="460">
      <v-card class="pa-2">
        <v-card-title class="warning--text headline">
          Alumini Student Not Found
        </v-card-title>
        <v-card-text>
          We could not find this alumini student.
          <span v-if="invalidAluminiStudentValue">
            Please check the student link and try again.
          </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="invalidAluminiStudentDialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {
  groupBy,
  formatPhoneNumber,
  toTitleCase,
  except,
} from "../../utils/helpers.js";
import moment from "moment";
import DedicationSalesByParsonTab from "../DediPro/DedicationSalesByParsonTab.vue";
import DedicationCommunications from "../DediPro/DedicationCommunications.vue";
import genvitePortalLink from "../components/GenvitePortalLink.vue";
export default {
  components: {
    DedicationSalesByParsonTab,
    DedicationCommunications,
    genvitePortalLink,
  },
  data: () => ({
    donor: null,
    phonesNumbers: [],
    transactions: [],
    children: [],
    allChildren: [],
    alumini: [],
    processing: false,
    loading: true,
    loadingChildren: true,
    aluminiDialog: false,
    limitedView: false,
    deleteMappedDialog: false,
    alreadyMappedDialog: false,
    invalidAluminiStudentDialog: false,
    invalidAluminiStudentValue: "",
    aluminiToDelete: {},
    alreadyMappedInfo: {},
    sales: "",
    commCount: 0,
    newAluminiMapping: {
      show: true,
      student: "",
      child: "",
      type: "",
    },

    rules: {
      required: (v) => {
        return !!v || "Required";
      },
    },
  }),
  async created() {
    if (this.$route.query.limitView) {
      this.limitedView = true;
    }

    await this.load();
  },
  methods: {
    async load() {
      await this.loadDonor();
    },
    async loadDonor() {
      const donor = await this.$http.get(
        "api/donors/getDonor?personID=" + this.$route.params.id
      );

      this.donor = donor;
      this.loading = false;

      this.loadPhones();
      this.loadTransactions();
      await this.loadChildren();
      await this.loadAlumini();

      if (this.$route.query.aluminiStudent) {
        this.openAluminiDialog(this.$route.query.aluminiStudent);
      }
    },
    async loadPhones() {
      const phones = await this.$http.get(
        "api/donors/GetPhones?personID=" + this.$route.params.id
      );

      this.phonesNumbers = phones;
    },
    async loadTransactions() {
      const transactions = await this.$http.get(
        "api/donors/GetTransactions?personID=" + this.$route.params.id
      );

      this.transactions = transactions;
    },
    async loadChildren() {
      const children = await this.$http.get(
        "api/donors/GetChildren?personID=" + this.$route.params.id
      );

      this.allChildren = children.map((child) => {
        const nameParts = [
          child.titleHebrew,
          child.firstHebrew,
          child.lastHebrew,
          child.suffixHebrew,
        ].filter((part) => !!part);
        const weddingYearText = child.weddingYear ? " (" + child.weddingYear + ")" : "";

        child.link = "/dinner/dinner-account-view/" + child.personID;
        child.displayName = nameParts.join(" ") + weddingYearText;

        child.mappingStatus = this.getChildMapping(child);

        return child;
      });

      this.children = this.allChildren;

      this.loadingChildren = false;

      this.$forceUpdate();
    },
    async loadAlumini() {
      let aluminiByParent = [];
      let aluminiByPerson = [];

      // Load alumini by parent ID
      if (this.donor.parentId) {
        aluminiByParent = await this.$http.get(
          "api/donors/GetAlumini?parentId=" + this.donor.parentId
        );
      }

      // Load alumini by person ID
      aluminiByPerson = await this.$http.get(
        "api/donors/GetAluminiByPersonID?personID=" + this.$route.params.id
      );

      // Combine both arrays and remove duplicates by studentID
      const combinedAlumini = [...aluminiByParent, ...aluminiByPerson];
      const uniqueAlumini = combinedAlumini.filter(
        (alumini, index, self) =>
          index === self.findIndex((a) => a.studentID === alumini.studentID)
      );

      this.alumini = uniqueAlumini.map((a) => {
        const isMapped = this.children.find((child) => {
          if (!child.aluminiPersons) return false;

          const aluminiPerson = child.aluminiPersons.find(
            (c) => c.studentID == a.studentID
          );

          return !!aluminiPerson;
        });

        a.disabled = isMapped;

        a.displayName =
          (a.firstHebrew ? a.firstHebrew : "Student ID: " + a.studentID) +
          " (" +
          a.class +
          ") | " +
          a.regID +
          (isMapped ? " | MAPPED" : "");

        return a;
      });
    },
    hasLimitedView() {
      if (this.limitedView) return true;

      const roles = Array.isArray(this.$store.state.authentication.roles)
        ? this.$store.state.authentication.roles
        : this.$store.state.authentication.roles
        ? this.$store.state.authentication.roles.split(",")
        : [];

      return roles.includes("Alumini");
    },
    hasAluminiStudentQuery() {
      return !!this.$route.query.aluminiStudent;
    },
    isAluminiStudentLocked() {
      return this.hasAluminiStudentQuery();
    },
    getPhoneType(phoneType) {
      switch (phoneType) {
        case "PHON":
          return "Home Phone";
        case "CEL":
          return "Cellphone";
        case "MCEL":
          return "Mother Cellphone";
      }
    },
    getProperties(transaction) {
      return Object.keys(
        except(transaction, "dateTime", "amount", "lastUpdated", "cCnum")
      )
        .map((key) => {
          return {
            name: toTitleCase(key),
            value: transaction[key],
          };
        })
        .filter((p) => p.value);
    },
    getStatusIcon(payment) {
      return "mdi-currency-usd";
    },
    getStatusIconColor(transaction) {
      return transaction.pmtType == "Pledge" ? "info" : "success";
    },
    openAluminiDialog(aluminiStudent) {
      if (aluminiStudent) {
        const student = this.alumini.find(
          (a) => a.studentID == aluminiStudent || a.id == aluminiStudent
        );

        if (!student) {
          this.invalidAluminiStudentValue = aluminiStudent;
          this.invalidAluminiStudentDialog = true;

          return;
        }

        const existingMapping = this.getMappingByStudentID(student.studentID);
        if (existingMapping) {
          this.alreadyMappedInfo = existingMapping;
          this.alreadyMappedDialog = true;
          return;
        }

        this.newAluminiMapping.student = student.displayName;
        this.newAluminiMapping.child = "";
        this.studentSelected(student.displayName);
        this.newAluminiMapping.show = true;
      } else {
        this.newAluminiMapping.student = "";
        this.newAluminiMapping.child = "";
        this.newAluminiMapping.type = "";
        this.newAluminiMapping.show = true;
      }

      this.aluminiDialog = true;
    },
    openNewAluminiMapping() {
      this.newAluminiMapping.student = "";
      this.newAluminiMapping.child = "";
      this.newAluminiMapping.type = "";

      this.newAluminiMapping.show = true;
    },
    closeNewAluminiMapping() {
      this.newAluminiMapping.student = "";
      this.newAluminiMapping.child = "";
      this.newAluminiMapping.type = "";
      this.$refs.student.resetValidation();
      this.$refs.child.resetValidation();

      this.newAluminiMapping.show = true;
    },
    studentSelected(value) {
      if (value) {
        const student = this.alumini.find((s) => s.displayName == value);

        this.newAluminiMapping.type =
          student.class.startsWith("B-") || student.class.startsWith("Y-")
            ? "Father"
            : "Mother";

        const filteredChildren =
          this.newAluminiMapping.type == "Father"
            ? this.allChildren.filter((c) => c.childType == "SON")
            : this.allChildren.filter((c) => c.childType == "SON IN LAW");

        this.children = filteredChildren.map((child) => {
          const disabled = this.isChildMappedForType(
            child,
            this.newAluminiMapping.type
          );

          return {
            ...child,
            disabled,
            mappingStatus: this.getChildMapping(child),
          };
        });

        const selectedChild = this.children.find(
          (c) => c.displayName == this.newAluminiMapping.child
        );
        if (selectedChild && selectedChild.disabled) {
          this.newAluminiMapping.child = "";
        }
      } else {
        this.newAluminiMapping.child = "";
        this.children = this.allChildren.map((child) => {
          return {
            ...child,
            disabled: false,
            mappingStatus: this.getChildMapping(child),
          };
        });
      }
    },
    isChildMappedForType(child, type) {
      return !!child.aluminiPersons.find((a) => a.type == type);
    },
    openDeleteMappedAluminiDialog(alumini) {
      this.aluminiToDelete = alumini;

      this.deleteMappedDialog = true;
    },
    async deleteExistingStudentMapping() {
      if (!this.alreadyMappedInfo.id) return;

      this.aluminiToDelete = { ...this.alreadyMappedInfo };
      await this.deleteAluminiMapping();

      this.alreadyMappedDialog = false;
      this.alreadyMappedInfo = {};

      const aluminiStudent = this.$route.query.aluminiStudent;
      if (aluminiStudent) {
        this.openAluminiDialog(aluminiStudent);
      }
    },
    async deleteAluminiMapping() {
      try {
        this.processing = true;

        await this.$http.post(
          "api/donors/deleteAluminiPerson?id=" + this.aluminiToDelete.id
        );

        this.processing = false;
        this.deleteMappedDialog = false;

        await this.loadChildren();
        await this.loadAlumini();
      } catch (e) {
        this.processing = false;
      }
    },
    async saveAlumini() {
      if (
        !this.$refs.student.validate(true) ||
        !this.$refs.child.validate(true)
      )
        return;

      const student = this.alumini.find(
        (s) => s.displayName == this.newAluminiMapping.student
      );

      if (student.disabled) {
        return this.$notify({
          group: "notification",
          text: "Student disabled",
          type: "error",
        });
      }

      const child = this.children.find(
        (s) => s.displayName == this.newAluminiMapping.child
      );

      try {
        this.processing = true;
        const studentID =
          student && student.studentID ? student.studentID : null;
        const aluminiID = student && student.id ? student.id : null;
        await this.$http.post("api/donors/SaveAluminiPerson", {
          personID: child.personID,
          studentID: studentID,
          aluminiID: aluminiID,
          type: this.newAluminiMapping.type,
          createdBy: this.$store.state.authentication.user,
        });

        this.$notify({
          text: "Mapping Saved",
          group: "notification",
          type: "success",
        });

        this.closeNewAluminiMapping();
        this.aluminiDialog = false;

        this.processing = false;

        await this.loadChildren();
        this.loadAlumini();
      } catch (e) {
        this.processing = false;
      }
    },
    getChildMapping(child = null) {
      if (!child) {
        if (!this.newAluminiMapping.child) return;

        child = this.children.find(
          (s) => s.displayName == this.newAluminiMapping.child
        );
      }

      if (!child.aluminiPersons.length) return;

      return this.getChildAluminiMappings(child)
        .map((mapping) => mapping.displayName.replace("● ", ""))
        .join(" | ");
    },
    getAluminiPersons(child) {
      if (!child.aluminiPersons.length) return;

      if (child.aluminiPersons.length == 2) {
        let text = "";

        child.aluminiPersons.forEach((aluminiPerson) => {
          const student = child.aluminiPersonStudents.find(
            (s) => s.studentID == aluminiPerson.studentID
          );

          text +=
            "● " +
            aluminiPerson.type +
            " Mapped" +
            (student
              ? " to " +
                student.firstHebrew +
                " " +
                student.lastHebrew +
                " (" +
                student.class +
                " | " +
                student.regID +
                ")"
              : "") +
            " ";
        });

        return text;
      }

      const aluminiPerson = child.aluminiPersons[0];

      const student = child.aluminiPersonStudents.find(
        (s) => s.studentID == aluminiPerson.studentID
      );

      return (
        "● " +
        aluminiPerson.type +
        " Mapped" +
        (student
          ? " to " +
            student.firstHebrew +
            " " +
            student.lastHebrew +
            " (" +
            student.class +
            " | " +
            student.regID +
            ")"
          : "")
      );
    },
    getChildAluminiMappings(child) {
      if (!child.aluminiPersons.length) return [];

      return child.aluminiPersons.map((aluminiPerson) => {
        const student = child.aluminiPersonStudents.find(
          (s) => s.studentID == aluminiPerson.studentID
        );

        return {
          id: aluminiPerson.id,
          childDisplayName: child.displayName,
          mappingType: aluminiPerson.type,
          studentDisplayName: student
            ? student.firstHebrew +
              " " +
              student.lastHebrew +
              " (" +
              student.class +
              " | " +
              student.regID +
              ")"
            : "Student ID: " + aluminiPerson.studentID,
          displayName:
            "● " +
            aluminiPerson.type +
            " Mapped" +
            (student
              ? " to " +
                student.firstHebrew +
                " " +
                student.lastHebrew +
                " (" +
                student.class +
                " | " +
                student.regID +
                ")"
              : ""),
        };
      });
    },
    getMappingByStudentID(studentID) {
      const child = this.allChildren.find((c) => {
        if (!c.aluminiPersons || !c.aluminiPersons.length) return false;
        return !!c.aluminiPersons.find((a) => a.studentID == studentID);
      });

      if (!child) return null;

      const aluminiPerson = child.aluminiPersons.find(
        (a) => a.studentID == studentID
      );
      if (!aluminiPerson) return null;

      const student = child.aluminiPersonStudents.find(
        (s) => s.studentID == studentID
      );
      return {
        id: aluminiPerson.id,
        childDisplayName: child.displayName,
        mappingType: aluminiPerson.type,
        studentDisplayName: student
          ? student.firstHebrew +
            " " +
            student.lastHebrew +
            " (" +
            student.class +
            " | " +
            student.regID +
            ")"
          : "Student ID: " + studentID,
      };
    },
  },
};
</script>
<style>
.v-expansion-panel__header {
  height: 63px;
}
.distribution-list {
  border: 1px solid #ddd !important;
}
.spacail-needs-link {
  color: rgb(76, 175, 80);
  display: inline-block;
  word-wrap: break-word;
  width: 100%;
}
.expansion-panel-margin .v-expansion-panel__header {
  margin-top: 5px;
  margin-bottom: 5px;
}
.child-mappings {
  margin-top: 4px;
  margin-bottom: 4px;
  margin-left: 16px;
}
.child-mapping-row {
  margin-bottom: 3px;
  min-height: 20px;
}
.child-mapping-text {
  line-height: 1.4;
}
.child-mapping-delete {
  margin-left: 4px;
}
.delete-family-line {
  font-size: 15px;
  line-height: 1.4;
}
.delete-mapping-caption {
  font-size: 13px;
  color: #666;
  margin-bottom: 4px;
}
.delete-mapping-info {
  font-size: 19px;
  line-height: 1.35;
  color: #0288d1;
  font-weight: 500;
}
</style>
